//import { useNavigate } from "react-router-dom";

export default function NavigateHome() {
//  const navigate = useNavigate();
//  navigate('/', { replace: true });

  window.location.replace('https://www.vactors.club');

  return null;
}